// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","actionBlack":"#2e2e2e","customWhite":"#ffffff","customGrey":"#4b4b4b","footerGrey":"#c0c0c0","borderGrey":"#d5dfdf","customBlackLt":"#202020","container":"_1NKpE8G3HeatDPm3Nco2JU","pressed":"_2nD6TDwF-0iaXhlGQJ7pz-","disabled":"_3KJgaLV51su1c-wMxukvb_"};


//////////////////
// WEBPACK FOOTER
// ./src/common/secondary-button/SecondaryButton.css
// module id = 292
// module chunks = 0 1 2